'use client';

import React from 'react';
import { Suggestion, SuggestionGroup } from '@tranquility-ai/theme-components/suggestion';
import './timeline-choice-cards.css';

export type TimelineChoiceOption = {
  value: string;
  label: string;
  description: string;
  icon: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
};

export type TimelineChoiceCardsProps = {
  ariaLabel: string;
  value: string;
  onChange: (value: string) => void;
  options: TimelineChoiceOption[];
};

export function TimelineChoiceCards({
  ariaLabel,
  value,
  onChange,
  options,
}: TimelineChoiceCardsProps) {
  return (
    <SuggestionGroup layout="grid" columns={2} aria-label={ariaLabel}>
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <Suggestion
            key={option.value}
            layout="card"
            size="md"
            label={option.label}
            description={option.description}
            leadingIcon={option.icon}
            disabled={option.disabled || option.loading}
            aria-pressed={selected}
            aria-busy={option.loading || undefined}
            className={selected ? 'timeline-choice-selected' : undefined}
            onClick={() => onChange(option.value)}
          />
        );
      })}
    </SuggestionGroup>
  );
}
